import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { LoadingState } from '@shared/types/loading-state';
import { loadPaymentFees, loadPaymentFeesFailure, loadPaymentFeesSuccess } from '../actions/load-payment-fees.actions';
import { paymentCheckout, paymentCheckoutFailure, paymentCheckoutSuccess } from '../actions/payment-checkout.actions';
import {
  paymentCheckoutStatus,
  paymentCheckoutStatusFailure,
  paymentCheckoutStatusSuccess,
} from '../actions/payment-checkout-status.actions';
import { paymentCharge, paymentChargeFailure, paymentChargeSuccess } from '../actions/payment-charge.actions';

export const featureKey = 'payments';

export interface State {
  loadingState: LoadingState;
  transactionId?: string;
  externalId?: string;
  paymentFees?: { amount: number; fees: number; net_amount: number };
}

export const initialState: State = {
  loadingState: 'not_loading',
  paymentFees: { amount: 0, fees: 0, net_amount: 0 },
};

export const paymentsReducer = createReducer(
  initialState,
  on(loadPaymentFees, paymentCheckout, paymentCheckoutStatus, paymentCharge, (state) => ({
    ...state,
    loadingState: 'loading' as LoadingState,
  })),
  on(loadPaymentFeesSuccess, (state, { amount, net_amount, fees }) => ({
    ...state,
    paymentFees: { amount, net_amount, fees },
  })),
  on(paymentCheckoutSuccess, (state, { transaction_id, external_id }) => ({
    ...state,
    transactionId: transaction_id,
    externalId: external_id,
  })),
  on(paymentCheckoutStatusSuccess, (state, { status }) => {
    if (['success', 'failed'].includes(status)) {
      return { ...state, transactionId: undefined, externalId: undefined };
    }
    return state;
  }),
  on(loadPaymentFeesSuccess, paymentCheckoutStatusSuccess, paymentChargeSuccess, paymentCheckoutSuccess, (state) => ({
    ...state,
    loadingState: 'loaded' as LoadingState,
  })),
  on(loadPaymentFeesFailure, paymentCheckoutFailure, paymentCheckoutStatusFailure, paymentChargeFailure, (state) => ({
    ...state,
    loadingState: 'not_loading' as LoadingState,
    transactionId: undefined,
    externalId: undefined,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return paymentsReducer(state, action);
}

export const paymentsFeatureSelector = createFeatureSelector<State>(featureKey);

export const selectPaymentsLoadingState = createSelector(paymentsFeatureSelector, (state: State) => state.loadingState);

export const selectPaymentFees = createSelector(paymentsFeatureSelector, (state: State) => state.paymentFees);

export const selectPaymentIds = createSelector(paymentsFeatureSelector, (state: State) => ({
  transactionId: state.transactionId,
  externalId: state.externalId,
}));
